import { Box, IconButton, VStack } from '@chakra-ui/react';

import DevSandboxTooltip from './DevSandbox/DevSandboxTooltip';
import useSandboxTheme from './DevSandbox/useSandboxTheme';
import GradientPopover from './GradientPopover';
import { LinkInput } from './LinkInput';
import ShareButtons from './ShareButtons';

const ShareNodesIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <circle cx="18" cy="5" r="3" />
    <circle cx="6" cy="12" r="3" />
    <circle cx="18" cy="19" r="3" />
    <line x1="8.59" y1="13.51" x2="15.42" y2="17.49" />
    <line x1="15.41" y1="6.51" x2="8.59" y2="10.49" />
  </svg>
);

interface ISolutionShareButtonProps {
  link: string;
  shareText: string;
  emailSubject: string;
  isMobile: boolean;
}

const SolutionShareButton = ({ link, shareText, emailSubject, isMobile }: ISolutionShareButtonProps) => {
  const { colors } = useSandboxTheme();

  return (
    <DevSandboxTooltip label="Share code">
      <Box display="inline-block">
      <GradientPopover
        triggerComponent={
          <IconButton
            aria-label="share solution popover with share buttons and link"
            size="md"
            variant="outline"
            borderColor={colors.controlBorder}
            color={colors.textSecondary}
            bg={colors.controlBg}
            _hover={{
              color: colors.textPrimary,
              bg: colors.hoverBg,
              borderColor: colors.controlBorderHover,
            }}
            _active={{ bg: colors.activeBg }}
          >
            <ShareNodesIcon />
          </IconButton>
        }
        width={isMobile ? '95vw' : '500px'}
        header="Spread the word about this solution"
      >
        <VStack alignItems="flex-start" spacing={4} width="100%">
          <ShareButtons text={shareText} link={link} emailSubject={emailSubject} />
          <LinkInput link={link} />
        </VStack>
      </GradientPopover>
      </Box>
    </DevSandboxTooltip>
  );
};

export default SolutionShareButton;
